// GLOBAL APP CONTROLLER

const initSlider = () => {
    const swiper = new Swiper('.block-logo-slider__slider', {
        // Optional parameters
        slidesPerView: 'auto',
        grabCursor: true,
        loop: true,
        speed: 10000,
        autoplay: {
            delay: 0,
            disableOnInteraction: true
        },
        freeMode: {
            enabled: true,
            sticky: false,
            momentum: false,
            momentumBounce: false,
            momentumRatio: 0,
            momentumVelocityRatio: 0
        }
    });
};

const controller = {
    init() {
        initSlider();
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
